import React from "react";
// import AppRoutes from "./AppRoutes";

import { SnackbarProvider } from "./context/snackbar-context";
import { UserProfileProvider } from "./context/userprofilecontext";
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
//import AppLayout from "./components/layout/AppLayout";
import AppRoutes from "./routes/AppRoutes";
import PrimaryDatabaseCheck from "./components/ui/primary-database-check";
import CurrentUserContextRequired from "./components/ui/current-context-required";
import CurrentCaseRequired from "./components/ui/current-case-required";
import TermsAcceptanceRequired from "./components/ui/terms-acceptance-required";
import {EnrichedTransactionPreloader} from './api/transactions.js';
import IdleTimeoutDialog from "./components/ui/IdleTimeoutDialog.js";
import { livisiblyTheme } from './design-system';

const theme = livisiblyTheme;

function App() {

  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <IdleTimeoutDialog
        idleTimeout={30 * 60 * 1000} //30 minutes
        redirectUrl={null}
        // warningDuration={2 * 60 * 1000} //2 minutes
        // activityEvents={[]}
        />
        <CssBaseline />
        <PrimaryDatabaseCheck>
        <UserProfileProvider>
          <SnackbarProvider>
            <CurrentUserContextRequired>
              <TermsAcceptanceRequired>
                <CurrentCaseRequired hideMessage={true}>
                  <EnrichedTransactionPreloader />
                </CurrentCaseRequired>
                <AppRoutes />
              </TermsAcceptanceRequired>
            </CurrentUserContextRequired>
          </SnackbarProvider>
        </UserProfileProvider>
        </PrimaryDatabaseCheck>
      </ThemeProvider>
    </BrowserRouter>
  )

}

export default App;
